import React from 'react';

import ContentContainer from 'components/ContentContainer/ContentContainer';
import SingleSpaMfe from 'components/SingleSpaMfe/SingleSpaMfe';

import { MfeBlockI, MfeBlockVariant } from 'interfaces/content-stack/modular-blocks/mfeBlockI';

import { MfeNames } from 'services/singleSpa';

export interface MfeBlockProps {
  data: MfeBlockI;
}

const VARIANT_TO_MFE_NAME_MAP = {
  [MfeBlockVariant.ECONOMIC_CALENDAR]: MfeNames.ECONOMIC_CALENDAR,
};

const MfeBlock: React.FC<MfeBlockProps> = ({ data }) => {
  return (
    <ContentContainer>
      <SingleSpaMfe name={VARIANT_TO_MFE_NAME_MAP[data.reference?.[0]?.mfeVariant]} />
    </ContentContainer>
  );
};

export default React.memo(MfeBlock);
